import React, {useContext, useEffect, useRef, useState} from "react";
import {Context} from "../../../../App";
import {useTranslation} from "react-i18next";
import ModalWindow from "../../../modal";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {Breadcrumb, Button, DatePicker, Form, notification, Select, Space, Spin, Table, Tag} from "antd";
import DB_ReportingPeriod from "../../../../database/dictionary/reporting_period";
import DB_TypeReportingPeriod from "../../../../database/dictionary/type_reporting_period";
import moment from "moment";
import DB_Branch from "../../../../database/dictionary/branch";
import axios from "axios";
import Input from "antd/es/input/Input";
import {SearchOutlined} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import BackButton from "../../../tech/back_button";

const EditReportingPeriod = () => {

    const {token, setToken} = useContext(Context);
    const {
        getReportingPeriod,
        createReportingPeriod,
        updateReportingPeriod,
        statusBranch,
        addBranches,
        deleteBranch
    } = DB_ReportingPeriod(token);
    const {getActiveBranches} = DB_Branch(token);
    const {getTypesReportingPeriod} = DB_TypeReportingPeriod(token);
    const {t} = useTranslation();
    const {errorConnect} = ModalWindow();
    const params = useLocation().state;
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [wait, setWait] = useState(true);
    const [typeReportingPeriod, setTypeReportingPeriod] = useState([]);
    const [isLoadSystem, setIsLoadSystem] = useState(true);
    const [data, setData] = useState([]);
    const [branch, setBranch] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState([]);
    const [newBranch, setNewBranch] = useState([]);
    const [addBranch, setAddBranch] = useState(false);
    const [hideBranches, setHideBranches] = useState(true);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);



    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (confirm, setSelectedKeys) => {
        setSelectedKeys([]);
        confirm();
        setSearchText('');
        setSearchedColumn('');
    };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
            <div
                style={{
                    padding: 8,
                }}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined/>}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => handleReset(confirm, setSelectedKeys)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1890ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={
                        text ? text.toString() : ''
                    }/>
            ) : (
                text
            ),
    });

    const columns = [
        {
            title: t('branch'),
            dataIndex: 'branch',
            key: 'branch_id',
            ...getColumnSearchProps('branch'),
        },
        {
            title: t('status'),
            dataIndex: 'status',
            filters: [
                {
                    text: t('close'),
                    value: 1
                },
                {
                    text: t('open'),
                    value: 0
                }
            ],
            onFilter: (value, record) => {
                return record.status === value
            },
            render: (status) => (
                <>
                    <Tag color={status === 1 ? 'volcano' : 'green'} key={status}>
                        {status === 1 ? t('close') : t('open')}
                    </Tag>
                </>
            ),
        },
        {
            title: t('actions'),
            dataIndex: 'operation',
            render: (_, record) => {
                return (
                    <>
                        <Button onClick={e => changeStatus(false, record.branch_id, record.status)}
                                type={'link'}>{record.status === 1 ? t('open') : t('close')}</Button>
                        <Button onClick={e => deleteBranchList(record.branch_id)} type={'link'}>{t('delete')}</Button>
                    </>
                )
            }
        },
    ]

    const changeStatus = (all, id = 0, status = 0) => {
        setWait(true);
        const formData = new FormData()
        formData.append('id', params.id)
        if (all) {
            formData.append('branch_id', selectedBranch)
            formData.append('status', 1);
        } else {
            formData.append('branch_id', [id])
            if (status === 1) {
                formData.append('status', 0)
            } else {
                formData.append('status', 1)
            }
        }

        statusBranch(formData)
            .then(res => {
                if (res.status === 200) {
                    setAddBranch(!addBranch);
                }
            })
            .catch(e => {
                if (e.request.status === 401) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            })
    }

    const deleteBranchList = (branch_id) => {
        setWait(true);
        const formData = new FormData;
        formData.append('id', params.id);
        formData.append('branch_id', branch_id);


        deleteBranch(formData)
            .then(res => {
                if (res.status === 200) {
                    setAddBranch(!addBranch);
                }
            })
            .catch(e => {
                if (e.request.status === 401) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            })
    }

    const action_branches = async (all = false) => {
        setWait(true);
        const formData = new FormData();

        if (all) {
            const all_a = branch.filter(b => {
                return !selectedBranch.includes(b.id)
            }).map(b => {
                return b.id
            })
            formData.append('branches', all_a);
        } else {
            formData.append('branches', newBranch);
        }

        formData.append('id', params.id)


        addBranches(formData)
            .then(res => {
                if (res.status === 200) {
                    setAddBranch(!addBranch);
                    setHideBranches(true);
                    setNewBranch([]);
                } else {
                    openNotificationFailed(t('updating'));
                }
            })
            .catch(e => {
                if (e.request.status === 401) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            });
    }

    // const deleteReportingPeriods = () => {
    //     setWait(true);
    //     const formData = new FormData();
    //     formData.append('id', params.id)
    //
    //
    //     deleteReportingPeriod(formData)
    //         .then(res => {
    //             if (res.status === 200) {
    //                 navigate('/site/documents-settings/reporting-periods', {replace: true})
    //             } else {
    //                 openNotificationFailed(t('deleting'));
    //             }
    //         })
    //         .catch(e => {
    //             if (e.request.status === 401) {
    //                 setToken(null)
    //             } else {
    //                 setWait(false)
    //                 errorConnect()
    //             }
    //         });
    // }


    const openNotificationFailed = (action) => {
        notification.error({
            message: t('failed'),
            description:
                t('e_update_create', {action: action, type: t('product_category').toLowerCase()}),
            placement: 'top'
        });
    };



    useEffect(() => {
        window.scroll(0, 0)
        axios.all([getTypesReportingPeriod(), getActiveBranches()])
            .then(axios.spread((types, branches) => {
                setTypeReportingPeriod(types.data['data']);
                setBranch(branches.data);
                setIsLoadSystem(false);
            }))
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            })
    }, [])

    useEffect(() => {
        if (!isLoadSystem) {
            if (params.id != null) {
                getReportingPeriod(params.id)
                    .then(res => {

                        form.setFieldsValue({
                            type_reporting_period_id: res.data['type_reporting_period_id'],
                            date: moment(res.data['date']),
                            // branches: res.data['details'].map(b => {
                            //     return b.branch_id
                            // })
                        });
                        setData(res.data['details'])
                        setSelectedBranch(res.data['details'].map(b => {
                            return b.branch_id
                        }))
                        setWait(false);
                    })
                    .catch(e => {
                        if (e.request.status === 403) {
                            setToken(null)
                        } else {
                            setWait(false)
                            errorConnect()
                        }
                    });
            } else {
                setWait(false);
            }
        }
    }, [isLoadSystem, addBranch])


    const onFinish = async (values) => {
        setWait(true);

        const formData = new FormData();
        formData.append('type_reporting_period_id', values["type_reporting_period_id"]);
        formData.append('date', values["date"].set('date', 1).format('DD.MM.YYYY'));

        if (params.id == null) {
            createReportingPeriod(formData)
                .then(res => {
                    if (res.status === 200) {
                        navigate("/site/documents-settings/reporting-periods", {replace: true});
                    } else {
                        openNotificationFailed(t('creating'));
                    }
                })
                .catch(e => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                });

        } else {
            formData.append('id', params.id)
            updateReportingPeriod(formData)
                .then(res => {
                    if (res.status === 200) {
                        navigate("/site/documents-settings/reporting-periods", {replace: true});
                    } else {
                        openNotificationFailed(t('updating'));
                    }
                })
                .catch(e => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                });
        }

    }

    const editPeriods = () => {
        return (
            <>
                <Space>
                    <Button onClick={e => setHideBranches(!hideBranches)}>{t('add_branches')}</Button>
                    <Button onClick={e => action_branches(true)}>{t('add_all_active_branches')}</Button>
                    <Button onClick={e => changeStatus(true)}
                            style={params.id == null ? {display: 'none'} : null}>{t('all_close')}</Button>
                </Space>
                <br/>
                <br/>

                <Space style={hideBranches ? {display: 'none'} : {marginBottom: '10pt'}}>
                    <Select
                        id={'add_branch_select'}
                        style={{width: '250pt'}}
                        showSearch
                        placeholder={t('add_branches')}
                        optionFilterProp="name"
                        optionLabelProp="name"
                        mode={"multiple"}
                        allowClear
                        value={newBranch}
                        onChange={e => setNewBranch(e)}
                    >
                        {branch.filter(b => {
                            return !selectedBranch.includes(b.id)
                        }).map(u =>
                            <Select.Option key={u.id} value={u.id} name={u.name}>{u.name}</Select.Option>
                        )}
                    </Select>
                    <Button onClick={e => action_branches()} type={'primary'}>OK</Button>
                </Space>

                <Table columns={columns}
                       dataSource={data}
                       rowKey="id"
                       loading={wait}
                       size={"small"}
                       pagination={false}
                    //style={{marginTop: '10pt'}}
                />
            </>
        )
    }


    return (
        <Spin spinning={wait} delay={300}>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>{t('reporting_period')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <BackButton />
                        <Button shape="round" type="primary" htmlType="submit" form={"form"}>
                            {t('save')}
                        </Button>
                    </Space>
                </Space>

                <Form
                    form={form}
                    labelCol={{span: 8}}
                    wrapperCol={{span: 10}}
                    layout={"vertical"}
                    onFinish={onFinish}
                    autoComplete="off"
                    id={"form"}
                >
                    <Form.Item style={{marginBottom: '10pt'}}
                               name="type_reporting_period_id"
                               label={t('type_reporting_periods')}
                               rules={[
                                   {
                                       required: true,
                                       message: t('e_select', {select: t('type_reporting_periods').toLowerCase()}),
                                   },
                               ]}
                               hasFeedback
                    >
                        <Select allowClear>
                            {typeReportingPeriod.map(u =>
                                <Select.Option key={u.id} value={u.id}>{u.name}</Select.Option>
                            )}
                        </Select>
                    </Form.Item>

                    <Form.Item style={{marginBottom: '10pt', height: 'auto'}}
                               name="date"
                               label={t('date')}
                               rules={[
                                   {
                                       required: true,
                                       message: t('e_select', {select: t('date').toLowerCase()}),
                                   },
                               ]}
                               hasFeedback
                    >

                        <DatePicker picker="month" format={'MMMM YYYY'}/>
                    </Form.Item>
                </Form>
                <br/>
                {params.id == null ? null : editPeriods()}
            </div>
            <Outlet/>
        </Spin>
    )
}

export default EditReportingPeriod;